import React, { useState, useEffect } from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import "./nosotros.css"
import DomoticNavbar from '../Components/Navbar';

const NosotrosPage = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const handleSlideChange = (index) => {
    setCurrentSlide(index);
  };

  return (
    <div className={`nosotros-container ${isVisible ? 'fade-in' : ''}`}>
      <DomoticNavbar/>
      <section className="hero-section">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h1>NOSOTROS</h1>
          <p>Conoce más sobre nuestra historia, valores y el equipo que hace posible nuestra visión</p>
        </div>
      </section>

      <section className="carousel-section">
        <div className="section-header">
          <h2>Nuestra Esencia</h2>
          <div className="divider"></div>
        </div>
        
        <Carousel 
          showArrows={true} 
          showThumbs={false} 
          showStatus={false} 
          autoPlay={true} 
          interval={6000} 
          infiniteLoop={true} 
          selectedItem={currentSlide} 
          onChange={handleSlideChange}
          className="custom-carousel"
        >
          <div className="carousel-slide">
            <div className="slide-content">
              <h3>Misión</h3>
              <p>Ofrecemos soluciones tecnológicas innovadoras y sostenibles que automatizan, protegen y transforman espacios corporativos y residenciales. En Domotic Control, combinamos inteligencia artificial, energía limpia, altos estándares técnicos y un equipo comprometido para garantizar la eficiencia, seguridad y satisfacción de nuestros clientes.</p>
            </div>
          </div>
          
          <div className="carousel-slide">
            <div className="slide-content">
              <h3>Visión</h3>
              <p>Ser referentes en el ecosistema tecnológico de la región, liderando el desarrollo e implementación de soluciones TIC que conecten personas, organizaciones y espacios inteligentes con eficiencia, responsabilidad ambiental y alto valor técnico</p>
            </div>
          </div>
          
          <div className="carousel-slide">
            <div className="slide-content">
              <h3>Valores Corporativos</h3>
              <div className="valores-lista">
                <div className="valor-item">
                  <div className="valor-icono">1</div>
                  <div className="valor-texto">
                    <span className="valor-titulo">Innovación Continua</span>
                    <p className="valor-descripcion">
                      Impulsamos el cambio tecnológico mediante soluciones creativas y de vanguardia que responden a las necesidades cambiantes del mercado.
                    </p>
                  </div>
                </div>
                <div className="valor-item">
                  <div className="valor-icono">2</div>
                  <div className="valor-texto">
                    <span className="valor-titulo">Excelencia Técnica</span>
                    <p className="valor-descripcion">
                      Garantizamos altos estándares de calidad en cada proyecto, con ingeniería precisa y tecnología confiable.
                    </p>
                  </div>
                </div>
                <div className="valor-item">
                  <div className="valor-icono">3</div>
                  <div className="valor-texto">
                    <span className="valor-titulo">Responsabilidad Ambiental</span>
                    <p className="valor-descripcion">
                      Desarrollamos soluciones sostenibles, promoviendo el uso de energía limpia y prácticas responsables con el entorno.
                    </p>
                  </div>
                </div>
                <div className="valor-item">
                  <div className="valor-icono">4</div>
                  <div className="valor-texto">
                    <span className="valor-titulo">Orientación al Cliente</span>
                    <p className="valor-descripcion">
                      Escuchamos, entendemos y acompañamos a nuestros clientes con un enfoque personalizado y humano en cada etapa del servicio.
                    </p>
                  </div>
                </div>
                <div className="valor-item">
                  <div className="valor-icono">5</div>
                  <div className="valor-texto">
                    <span className="valor-titulo">Confianza y Transparencia</span>
                    <p className="valor-descripcion">
                      Actuamos con integridad y claridad, generando relaciones sólidas y duraderas con nuestros clientes y aliados.
                    </p>
                  </div>
                </div>
                <div className="valor-item">
                  <div className="valor-icono">6</div>
                  <div className="valor-texto">
                    <span className="valor-titulo">Compromiso con la Transformación Digital</span>
                    <p className="valor-descripcion">
                      Conectamos a empresas y hogares con el futuro, integrando tecnologías inteligentes que optimizan procesos y mejoran la calidad de vida.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Carousel>
        
        <div className="carousel-indicators">
          {['Misión', 'Visión', 'Valores Corporativos'].map((item, index) => (
            <button 
              key={index} 
              className={`indicator ${currentSlide === index ? 'active' : ''}`}
              onClick={() => handleSlideChange(index)}
            >
              {item}
            </button>
          ))}
        </div>
      </section>
    </div>
  );
};

export default NosotrosPage;